import type { CSSProperties, FC } from 'react';
import { useMemo } from 'react';
import classNames from 'classnames';
import { useLockFn } from 'ahooks';
import type { ButtonProps } from 'antd-mobile/es/components/button';
import { Button } from 'antd-mobile';

import { getCDNAssets } from '@/utils';
import ProductCardPrice from '../../../Menu/List/Card/Price';
import DynamicComboPromotionTip from './PromotionTip';

import styles from './dcfooteraction.module.less';

export type DCFooterActionProps = {
  className?: string;
  style?: CSSProperties;
  fromCart?: boolean;
  cutPrice?: number;
  price?: number;
  calcPrice?: boolean;
  addCartBtnProps?: Partial<ButtonProps>;
  onAddCart?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => Promise<void> | void;
  onCustomClick?: () => void;
};

const DCFooterAction: FC<DCFooterActionProps> = (props) => {
  const { className, style, fromCart, cutPrice, price, calcPrice, addCartBtnProps, onAddCart, onCustomClick } = props;

  const addCart = useLockFn(async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if (onAddCart) {
      await onAddCart(e);
    }
  });

  const cartText = useMemo(() => {
    if (price != null || calcPrice === false) {
      if (fromCart) {
        return '保存修改';
      }
      return '加入购物车';
    }
    return '选好了';
  }, [calcPrice, fromCart, price]);

  return (
    <div className={classNames(styles.wrapper, className)} style={style}>
      <div className={styles.listDetailBtn} onClick={onCustomClick}>
        <img className={styles.listDetailBtnImg} src={getCDNAssets('dc_combo_bottom_detail_icon.png')} />
        <div className={styles.listDetailBtnText}>定制</div>
      </div>

      <Button className={styles.addCartBtn} shape="rounded" color="primary" onClick={addCart} {...addCartBtnProps}>
        {price != null && (
          <ProductCardPrice
            className={styles.addCartBtnPrice}
            priceNumClassName={styles.addCartBtnPriceNum}
            priceLastClassName={styles.addCartBtnPriceLast}
            originalPrice={price}
          />
        )}
        <span className={styles.addCartBtnTxt}>{cartText}</span>
      </Button>
      {cutPrice != null && <DynamicComboPromotionTip className={styles.cutTip} price={cutPrice} />}
    </div>
  );
};

export default DCFooterAction;
